import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { format, isSameDay } from 'date-fns'
import { Modal } from 'react-bootstrap'
import { ExternalLink as ExternalLinkIcon } from 'react-feather'
// import { imgBaseUrl } from 'lib/cloudinary'
import PoweredBy from 'components/powered-by'
import style from '../style.module.css'

const InfoModal = ({ isOpen, onClose }) => {

    const { t } = useTranslation()
    const event = useSelector(state => state.event)

    const startEnd = useMemo(() => {
        const sDate = new Date(event.startsAt)
        const eDate = new Date(event.endsAt)
        const sameDay = isSameDay(sDate, eDate)
        if (sameDay) {
            return format(sDate, 'PP p') + ' - ' + format(eDate, 'p') // + ' (' + Intl.DateTimeFormat().resolvedOptions().timeZone + ')'
        } else {
            return format(sDate, 'PP p') + ' - ' + format(eDate, 'PP p') // + ' (' + Intl.DateTimeFormat().resolvedOptions().timeZone + ')'
        }
    }, [event])

    return (
        <Modal show={isOpen} onHide={onClose} centered>
            <Modal.Header closeButton onHide={onClose}>{t('eventInfo')}</Modal.Header>
            <Modal.Body className='p-0 bg-white'>
                {!!event.bannerUrl && (
                    <img src={event.bannerUrl} alt='' className='w-100 h-auto' />
                )}
                <div className='p-3'>
                    {/* <h3>{event.name}</h3> */}
                    {!!event.logoUrl && (
                        <div className='text-center mb-2'><img src={event.logoUrl} alt={event.name} title={event.name} className={style.infoLogo} /></div>
                    )}
                    <p className='small text-muted'>
                        <strong>{event.name}</strong><br />
                        {event.hostedBy && <>{t('hostedByName', { name: event.hostedBy })}<br /></>}
                        {event.venuName && <>{event.venueName}<br /></>}
                        {startEnd}
                    </p>
                    <p className='small mb-2'>{event.description}</p>
                    {!!event.websiteUrl && (
                        <p className='mb-0'>
                            <a href={event.websiteUrl} target='_blank' rel='noopener noreferrer noindex nofollow'>
                                {t('visitWebsite')}
                                <ExternalLinkIcon style={{ height: '1rem', verticalAlign: 'top', marginTop: '0.25rem' }} />
                            </a>
                        </p>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <PoweredBy />
            </Modal.Footer>
        </Modal>
    )

}

export default InfoModal